// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function decode(json) {
  return {
          languageCode: Json_decode.field("languageCode", Json_decode.string, json),
          questions: {
            usefulness: Json_decode.field("questions", (function (param) {
                    return Json_decode.field("usefulness", Json_decode.string, param);
                  }), json),
            aiInterference: Json_decode.field("questions", (function (param) {
                    return Json_decode.field("aiInterference", Json_decode.string, param);
                  }), json),
            contentQuality: Json_decode.field("questions", (function (param) {
                    return Json_decode.field("contentQuality", Json_decode.string, param);
                  }), json)
          },
          labels: {
            title: Json_decode.field("labels", (function (param) {
                    return Json_decode.field("title", Json_decode.string, param);
                  }), json),
            submit: Json_decode.field("labels", (function (param) {
                    return Json_decode.field("submit", Json_decode.string, param);
                  }), json),
            update: Json_decode.field("labels", (function (param) {
                    return Json_decode.field("update", Json_decode.string, param);
                  }), json),
            saved: Json_decode.field("labels", (function (param) {
                    return Json_decode.field("saved", Json_decode.string, param);
                  }), json),
            error: Json_decode.field("labels", (function (param) {
                    return Json_decode.field("error", Json_decode.string, param);
                  }), json)
          },
          submitted: Json_decode.field("submitted", Json_decode.bool, json),
          usefulness: Caml_option.null_to_opt(Json_decode.field("usefulness", (function (param) {
                      return Json_decode.nullable(Json_decode.$$int, param);
                    }), json)),
          aiInterference: Caml_option.null_to_opt(Json_decode.field("aiInterference", (function (param) {
                      return Json_decode.nullable(Json_decode.$$int, param);
                    }), json)),
          contentQuality: Caml_option.null_to_opt(Json_decode.field("contentQuality", (function (param) {
                      return Json_decode.nullable(Json_decode.$$int, param);
                    }), json))
        };
}

function questions(feedback) {
  return feedback.questions;
}

function labels(feedback) {
  return feedback.labels;
}

function submitted(feedback) {
  return feedback.submitted;
}

function usefulness(feedback) {
  return feedback.usefulness;
}

function aiInterference(feedback) {
  return feedback.aiInterference;
}

function contentQuality(feedback) {
  return feedback.contentQuality;
}

export {
  decode ,
  questions ,
  labels ,
  submitted ,
  usefulness ,
  aiInterference ,
  contentQuality ,
}
/* No side effect */
